import clsx from "clsx";
import { type SVGAttributes } from "react";

import styles from "./Logo.module.css";

type Props = SVGAttributes<SVGElement>;

const FreshAidLogoFull = (props: Props) => {
    const { className, ...otherProps } = props;

    return (
        <svg
            {...otherProps}
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 914 274"
            className={clsx(className, styles.svg)}
        >
            <path
                d="M139.93 150.96c10.98 15.6-95.05 130.41-131.91 78.1-44.43-63.06 122.07-92.08 131.91-78.1Z"
                style={{
                    fill: "#8cc765",
                }}
            />
            <path
                d="M139.83 125.96c-6.79 10.66-141.38-7.14-123.02-71.29 21.23-74.16 136.18 50.63 123.02 71.29Z"
                style={{
                    fill: "#458140",
                }}
            />
            <path
                d="M162.77 150.58c2.62-9.7 117.54-2.35 112.72 36.25-7.81 62.49-119.22-12.18-112.72-36.25Z"
                style={{
                    fill: "#fdde3f",
                }}
            />
            <path
                d="M164.41 125.67c4.97 8.26 97.39-12.72 86.9-43.6-14.56-42.89-96.52 27.61-86.9 43.6Z"
                style={{
                    fill: "#f9a41a",
                }}
            />
            <path
                d="M358.4 178.11c0 5.05-4.1 9.15-9.15 9.15s-9.14-4.1-9.14-9.15V89c0-5.05 4.1-9.15 9.14-9.15h49.21c4.57 0 8.2 3.63 8.2 8.2s-3.63 8.2-8.2 8.2H358.4v29.18h29.81c4.42 0 8.04 3.63 8.04 8.04s-3.63 8.04-8.04 8.04H358.4v36.59ZM430.18 122.44c3-6.15 10.41-10.09 17.03-10.09 4.42 0 8.04 3.63 8.04 8.04s-3.62 8.04-8.04 8.04c-10.89 0-17.03 6.94-17.03 17.51v32.81c0 4.73-3.79 8.52-8.52 8.52s-8.52-3.78-8.52-8.52v-57.1c0-4.73 3.79-8.52 8.52-8.52s8.52 3.79 8.52 8.52v.79ZM493.59 112.18c26.66 0 31.55 20.51 31.55 31.39 0 5.84 0 12.62-9.62 12.62h-38.96c0 11.36 8.04 16.56 18.45 16.56 6.94 0 11.83-2.37 15.61-4.89 1.74-1.1 3-1.73 5.05-1.73a7.4 7.4 0 0 1 7.41 7.41c0 2.52-1.26 4.57-2.68 5.84-2.68 2.52-11.04 8.67-25.39 8.67-21.92 0-35.49-11.83-35.49-38.17 0-24.13 12.62-37.69 34.07-37.69Zm-16.56 29.81h31.23c0-7.73-4.42-15.3-14.67-15.3-9.14 0-15.77 5.2-16.56 15.3ZM553.07 133c0 11.67 38.8 6.31 38.8 32.33 0 14.82-12.62 22.4-28.86 22.4-13.56 0-23.98-6.15-27.92-11.04-1.26-1.58-1.9-3-1.9-4.89 0-4.1 3.47-7.57 7.57-7.57 1.57 0 3.15.47 4.89 1.89 4.26 3.47 9.47 6.47 17.35 6.47 7.09 0 11.67-1.89 11.67-6.31 0-12.78-38.64-6.15-38.64-32.97 0-14.19 11.83-21.13 26.34-21.13 11.2 0 21.13 4.26 25.55 9.78.95 1.26 1.57 2.37 1.57 4.73 0 4.1-3.47 7.57-7.57 7.57-2.21 0-3.63-.95-5.36-2.21-3.47-2.52-7.73-5.05-14.2-5.05-5.83 0-9.3 2.05-9.3 5.99ZM621.05 121.65c3-4.57 9.62-9.47 20.19-9.47 21.45 0 26.5 13.72 26.5 27.45v39.43c0 4.73-3.78 8.2-8.52 8.2-5.05 0-8.52-3.47-8.52-8.2v-36.27c0-8.99-3.62-15.14-13.88-15.14-11.83 0-15.77 6.94-15.77 16.25v35.17c0 4.73-3.63 8.2-8.52 8.2s-8.52-3.47-8.52-8.2V82.23c0-4.73 3.79-8.52 8.52-8.52s8.52 3.79 8.52 8.52v39.43ZM740.62 158.4 731 181.27c-1.42 3.32-4.42 5.99-8.52 5.99-4.89 0-8.99-4.1-8.99-8.99 0-.95.16-2.21.63-3.31l37.22-90.69c.95-2.21 3.47-5.68 8.36-5.68s7.42 3.47 8.36 5.68l37.22 90.69c.47 1.1.63 2.37.63 3.31 0 4.89-4.1 8.99-8.99 8.99-4.1 0-7.1-2.68-8.52-5.99l-9.62-22.87h-38.17Zm19.08-49.85-12.93 33.12h25.87l-12.94-33.12ZM816.02 94.68c0-7.26 3.62-10.41 10.09-10.41s10.25 3.15 10.25 10.41c0 6.15-3.63 9.94-10.25 9.94s-10.09-3.79-10.09-9.94Zm18.61 84.06c0 4.73-3.79 8.52-8.52 8.52s-8.52-3.78-8.52-8.52v-57.1c0-4.73 3.79-8.52 8.52-8.52s8.52 3.79 8.52 8.52v57.1ZM896.47 118.49V82.22c0-4.73 3.79-8.52 8.52-8.52s8.52 3.79 8.52 8.52v74.29c0 20.98-13.56 31.54-32.65 31.54-21.29 0-33.75-12.14-33.75-37.85s12.14-38.01 32.02-38.01c7.57 0 14.2 3.15 17.35 6.31Zm0 16.25s-6.15-8.04-15.61-8.04c-10.73 0-16.88 7.89-16.88 23.5s5.99 23.34 16.88 23.34c9.15 0 15.61-6.15 15.61-17.03v-21.77Z"
                style={{
                    fill: "#404041",
                }}
            />
        </svg>
    );
};

export { FreshAidLogoFull };
export type { Props as MainLogoProps };
